// Text is the only signal: see docs/memory/oauth-auto-register-tracking.md
const REFERRAL_ERROR_MARKERS = ['código de referido', 'referral code']

export const isReferralCodeError = (message: string) =>
  REFERRAL_ERROR_MARKERS.some(marker => message.includes(marker))

const STORAGE_KEY = 'referral_code_error'

/** Carries the rejection across the redirect to the register page. */
export const storeReferralError = (message: string) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, message)
  } catch {
    // Private-mode storage must not fail the redirect.
  }
}

/** Reads the pending rejection and clears it. */
export const takeReferralError = () => {
  try {
    const message = sessionStorage.getItem(STORAGE_KEY)
    if (message) sessionStorage.removeItem(STORAGE_KEY)
    return message
  } catch {
    return null
  }
}
